var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Slider } from '../../components/SlideDown';
export class Story extends Component {
    constructor() {
        super('Story', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-back-to-story').on('click', (event, button) => {
                event.preventDefault();
                $.scrollTo($(button.attr('href')).position().y - $('header').height(), 250);
                Slider.close(button.parents('.box').find('.slide-down'));
            }).on('mouseenter', (event, button) => {
                if ($(window).width() < 992)
                    return;
                $('.info-block').removeClass('d-none').find('.info-title').text('«' + $(button.attr('href')).find('h2').text() + '»');
                this.positionInfoBlock(event, true);
            }).on('mousemove', (event, button) => {
                if ($(window).width() < 992)
                    return;
                this.positionInfoBlock(event, true);
            }).on('mouseleave', (event, button) => {
                $('.info-block').addClass('d-none');
            });
            ;
            $('a[href^="https://theatredecarouge.ch/note/"]').on('click', (event, button) => {
                event.preventDefault();
                const name = button.attr('href').replace('https://theatredecarouge.ch/note/', '').replace('/', '');
                const target = $(window).width() >= 768 ? $('.note-md[data-name="' + name + '"]') : $('.note-xs[data-name="' + name + '"]');
                $.scrollTo(target.position().y - $('header').height(), 250);
                Slider.open(target.find('.slide-down'));
            }).on('mouseenter', (event, button) => {
                if ($(window).width() < 992)
                    return;
                const name = button.attr('href').replace('https://theatredecarouge.ch/note/', '').replace('/', '');
                const target = $(window).width() >= 992 ? $('.note-md[data-name="' + name + '"]') : $('.note-xs[data-name="' + name + '"]');
                $('.info-block').removeClass('d-none').find('.info-title').text('«' + target.find('h2').text() + '»');
                this.positionInfoBlock(event);
            }).on('mousemove', (event, button) => {
                if ($(window).width() < 992)
                    return;
                this.positionInfoBlock(event);
            }).on('mouseleave', (event, button) => {
                $('.info-block').addClass('d-none');
            });
            this.success();
        });
    }
    positionInfoBlock(event, alignRight = false) {
        $('.info-block').css({
            top: (event.pageY + 10) + 'px',
        });
        if (alignRight) {
            $('.info-block').css({
                right: ($(window).width() - event.pageX + 10) + 'px',
                left: ''
            });
        }
        else {
            $('.info-block').css({
                left: (event.pageX + 10) + 'px',
                right: ''
            });
        }
    }
}
